export default __webpack_public_path__ + "6cbab6dc819797efdb085ebeac150bde.png";